import {ClientServices} from "./client.services";
import {ClientActionTypes} from "./client.types";
import {processStatusData} from "./client.reducer";

export const getClientSoftwareDataDownloads = (userEmailAddress) => {
    return (dispatch, getState) => {
        ClientServices.getSoftwareDataDownloads(userEmailAddress).then(response => {
            dispatch({
                type: ClientActionTypes.GET_SOFTWARE_DATA_DOWNLOADS,
                payload: response != null && response.license ? response.license : []
            })
        })
    }
}

export const getQueuedData = (email, memberId) => {
    return (dispatch, getState) => {
        ClientServices.queuedData(email, memberId).then(response => {
            let currentData = (response !== undefined ? processStatusData(response.jobStatus) : null)
            let myResults = currentData.filter(e => e.Status.toUpperCase() === "COMPLETED" || e.Status.toUpperCase() === "FAILED" || e.Status.toUpperCase() === "CANCELLED")
            let myJobs = currentData.filter(e => e.Status.toUpperCase() === "QUEUED" || e.Status.toUpperCase() === "RUNNING")

            dispatch({
                type: ClientActionTypes.GET_COMPLETED_DATA,
                payload: myResults
            })

            dispatch({
                type: ClientActionTypes.GET_QUEUED_DATA,
                payload: myJobs
            })
            /*dispatch({
                type: ClientActionTypes.GET_QUEUED_DATA,
                payload: (response !== undefined ? response.jobStatus : null)
            })*/
        })
    }
}
/*export const getCompletedData = (email, memberId) => {
    return (dispatch, getState) => {
        ClientServices.completedData(email, memberId).then(response => {
            dispatch({
                type: ClientActionTypes.GET_COMPLETED_DATA,
                payload: (response !== undefined ? response.jobResults : null)
            })
        })
    }
}*/

export const getClientOrderHistory = (memberId) => {
    return (dispatch, getState) => {
        ClientServices.getOrderHistory(memberId).then(response => {
            dispatch({
                type: ClientActionTypes.GET_ORDER_HISTORY,
                payload: response != null && response.userOrderHistory ? response.userOrderHistory : []
            })
        })
    }
}

export const getModelJobStatus = () => {
    return (dispatch, getState) => {
        ClientServices.getModelJobStatus().then(response => {
            dispatch({
                type: ClientActionTypes.GET_MODEL_JOB_STATUS,
                payload: response
            })
        })
    }
}

export const getTrainingCertificates = (memberId) => {
    return (dispatch, getState) => {
        ClientServices.getTrainingCertificates(memberId).then(response => {
            dispatch({
                type: ClientActionTypes.TRAINING_CERTIFICATES,
                payload: response != null && response.trainingCertificate ? response.trainingCertificate : []
            })
        })
    }
}

export const getWebinars = (memberId) => {
    return (dispatch, getState) => {
        ClientServices.getWebinars(memberId).then(response => {
            dispatch({
                type: ClientActionTypes.WEBINAR,
                payload: response != null && response.webinar ? response.webinar : []
            })
        })
    }
}


export const getOldOrderHistory = (emailAddress) => {
    return (dispatch, getState) => {
        ClientServices.getOldOrderHistory(emailAddress).then(response => {
            let responseArray = response && response.LegacyTrainingHistoryResult;
            
            //response.LegacyTrainingHistory;

            let oldOrderHistory = responseArray!=undefined && responseArray.LegacyTrainingWebClassHistory!=undefined ? responseArray.LegacyTrainingWebClassHistory : [];
            //responseArray && responseArray.filter(element => element.SessionTypeName === "Webinar" || element.SessionTypeName === "Classroom");
            let oldOnDemand = responseArray!=undefined && responseArray.LegacyTrainingOnDemandHistory ? responseArray.LegacyTrainingOnDemandHistory : [];//responseArray && responseArray.filter(element => element.SessionTypeName === "OnDemand");
            let oldLearning = responseArray!=undefined && responseArray.LegacyTrainingELearningHistory ? responseArray.LegacyTrainingELearningHistory : [];//responseArray && responseArray.filter(element => element.SessionTypeName === "ELearning");

            dispatch({
                type: ClientActionTypes.OLD_ORDER_HISTORY,
                payload: oldOrderHistory
            });

            dispatch({
                type: ClientActionTypes.OLD_ON_DEMAND,
                payload: oldOnDemand
            });

            dispatch({
                type: ClientActionTypes.OLD_LEARNING,
                payload: oldLearning
            });
        })
    }
};

export const getELearningList = (memberID) => {
    return (dispatch, getState) => {
        ClientServices.getELearningList(memberID).then(response => {
            dispatch({
                type: ClientActionTypes.ELEARNING_LIST,
                payload: response && response.data.elearning
            })
        });
    }
};

export const getBRMSKey = (emailAddress, memberId) => {
    return (dispatch, getState) => {
        ClientServices.getBRMSKey(emailAddress, memberId).then(response => {
            dispatch({
                type: ClientActionTypes.BRMS_KEY,
                payload: response !== null && response.key ? response.key.BRMSKey : ""
            })

            dispatch({
                type: ClientActionTypes.BRMS_USER_ID,
                payload: response !== null && response.key ? response.key.BRMSUserID : ""
            })
        })
    }
};

export const clearClient = () => {
    return (dispatch, getState) => [
        dispatch({type: ClientActionTypes.TRAINING_CERTIFICATES, payload: []}),
        dispatch({type: ClientActionTypes.WEBINAR, payload: []}),
        dispatch({type: ClientActionTypes.GET_MODEL_JOB_STATUS, payload: []}),
        dispatch({type: ClientActionTypes.GET_SOFTWARE_DATA_DOWNLOADS, payload: []}),
        dispatch({type: ClientActionTypes.GET_QUEUED_DATA, payload: []}),
        dispatch({type: ClientActionTypes.GET_COMPLETED_DATA, payload: []}),
        dispatch({type: ClientActionTypes.GET_ORDER_HISTORY, payload: []}),
        dispatch({type: ClientActionTypes.ELEARNING_LIST, payload: []}),
        dispatch({type: ClientActionTypes.BRMS_KEY, payload: {}}),
        dispatch({type: ClientActionTypes.GET_COMPLETED_DATA, payload: []}),
        dispatch({type: ClientActionTypes.GET_QUEUED_DATA, payload: []}),
    ]
};

export const getClientData = (emailAddress, memberId) => {
    return (dispatch, getState) => {
        dispatch(getClientSoftwareDataDownloads(memberId ? memberId : ''));
        dispatch(getQueuedData(emailAddress, memberId ? memberId : ''));
        // dispatch(getCompletedData(emailAddress, memberId ? memberId : ''));
        dispatch(getClientOrderHistory(memberId ? memberId : ''));
        dispatch(getTrainingCertificates(memberId ? memberId : ''));
        dispatch(getWebinars(memberId ? memberId : ''));
        dispatch(getBRMSKey(emailAddress, memberId ? memberId : ''));
        // dispatch(getCompletedData(emailAddress));
        dispatch(getQueuedData(emailAddress));
        dispatch(getOldOrderHistory(emailAddress));
        dispatch(getELearningList());
    }
};

/*

const completedData = {
    "jobStatus": [
        {
            "RunId": 1,
            "InvoiceAmount": 0,
            "CpuClock": 0,
            "WorkEstimate": 0,
            "ArrivalTime": "30/11/07 07:29:15",
            "AmpFile": "20071130-072911.400872.amp",
            "ResultsHttp": "cancelled",
            "StartTime": "30/11/07 23:45:43",
            "EndTime": "09/10/08 19:35:48",
            "Executable": "AERMOD_EPA_MPI_07026.exe",
            "ProjectName": "R11NQSNOX06.dat",
            "MemoText": "",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 261,
            "QUserId": 16,
            "MyJobWait": 0,
            "RuntimeFee": 0,
            "ServerFee": 0,
            "QueDiscount": 0,
            "InvoiceFlag": true,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 2,
            "InvoiceAmount": 72.6194444444444,
            "CpuClock": 0,
            "WorkEstimate": 348.793212890625,
            "ArrivalTime": "09/10/08 17:33:21",
            "StartTime": "09/10/08 19:35:48",
            "EndTime": "09/10/08 21:49:53",
            "AmpFile": "a20081009-173320.752390.amp",
            "ResultsHttp": "http://remote.aermod.com/Results/4979E28B892C2D4BFF5E63AA149A36DF/R1NQSSOXOns_Fine.amr",
            "Executable": "AERMOD_EPA_MPI_07026.exe",
            "ProjectName": "R1NQSSOXOns_Fine.ami",
            "MemoText": "072101.0052.01",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 36.3097222222222,
            "ServerFee": 36.3097222222222,
            "QueDiscount": 0,
            "InvoiceFlag": true,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 3,
            "InvoiceAmount": 12,
            "CpuClock": 0,
            "WorkEstimate": 43.89665,
            "ArrivalTime": "03/10/11 13:42:15",
            "StartTime": "03/10/11 15:21:25",
            "EndTime": "03/10/11 15:25:35",
            "AmpFile": "20111003-134211.579040.amp",
            "ResultsHttp": null,
            "Executable": "AERMOD_EPA_MPI_11103.exe",
            "ProjectName": "TAMKO_S1_Silica_2009.ami",
            "MemoText": "112101.0058",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 1.742409,
            "ServerFee": 1.742409,
            "QueDiscount": 0,
            "InvoiceFlag": false,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 4,
            "InvoiceAmount": 10,
            "CpuClock": 0,
            "WorkEstimate": 43.89665,
            "ArrivalTime": "",
            "StartTime": "03/10/2011 15:21:25",
            "EndTime": "1/1/1900 00:00:00",
            "AmpFile": "20111003-134211.579040.amp",
            "ResultsHttp": "",
            "Executable": "AERMOD_EPA_MPI_11103.exe",
            "ProjectName": "TAMKO_S1_Silica_2009.ami",
            "MemoText": "112101.0058",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 1.742409,
            "ServerFee": 1.742409,
            "QueDiscount": 0,
            "InvoiceFlag": false,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 5,
            "InvoiceAmount": 10,
            "CpuClock": 0,
            "WorkEstimate": 43.89665,
            "ArrivalTime": "",
            "StartTime": "03/10/2011 15:21:25",
            "EndTime": "",
            "AmpFile": "20111003-134211.579040.amp",
            "ResultsHttp": "",
            "Executable": "AERMOD_EPA_MPI_11103.exe",
            "ProjectName": "TAMKO_S1_Silica_2009.ami",
            "MemoText": "112101.0058",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 1.742409,
            "ServerFee": 1.742409,
            "QueDiscount": 0,
            "InvoiceFlag": false,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
    ]
}

const queuedData = {
    "jobStatus": [
        {
            "RunId": 6,
            "InvoiceAmount": 0,
            "CpuClock": 0,
            "WorkEstimate": 0,
            "ArrivalTime": "30/11/07 07:29:15",
            "AmpFile": "20071130-072911.400872.amp",
            "ResultsHttp": "cancelled",
            "StartTime": "30/11/07 23:45:43",
            "EndTime": "09/10/08 19:35:48",
            "Executable": "AERMOD_EPA_MPI_07026.exe",
            "ProjectName": "R11NQSNOX06.dat",
            "MemoText": "",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 261,
            "QUserId": 16,
            "MyJobWait": 0,
            "RuntimeFee": 0,
            "ServerFee": 0,
            "QueDiscount": 0,
            "InvoiceFlag": true,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 7,
            "InvoiceAmount": 72.6194444444444,
            "CpuClock": 0,
            "WorkEstimate": 348.793212890625,
            "ArrivalTime": "09/10/08 17:33:21",
            "StartTime": "09/10/08 19:35:48",
            "EndTime": "09/10/08 21:49:53",
            "AmpFile": "a20081009-173320.752390.amp",
            "ResultsHttp": "http://remote.aermod.com/Results/4979E28B892C2D4BFF5E63AA149A36DF/R1NQSSOXOns_Fine.amr",
            "Executable": "AERMOD_EPA_MPI_07026.exe",
            "ProjectName": "R1NQSSOXOns_Fine.ami",
            "MemoText": "072101.0052.01",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 36.3097222222222,
            "ServerFee": 36.3097222222222,
            "QueDiscount": 0,
            "InvoiceFlag": true,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 8,
            "InvoiceAmount": 12,
            "CpuClock": 0,
            "WorkEstimate": 43.89665,
            "ArrivalTime": "03/10/11 13:42:15",
            "StartTime": "03/10/11 15:21:25",
            "EndTime": "03/10/11 15:25:35",
            "AmpFile": "20111003-134211.579040.amp",
            "ResultsHttp": null,
            "Executable": "AERMOD_EPA_MPI_11103.exe",
            "ProjectName": "TAMKO_S1_Silica_2009.ami",
            "MemoText": "112101.0058",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 1.742409,
            "ServerFee": 1.742409,
            "QueDiscount": 0,
            "InvoiceFlag": false,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 9,
            "InvoiceAmount": 10,
            "CpuClock": 0,
            "WorkEstimate": 43.89665,
            "ArrivalTime": "",
            "StartTime": "03/10/2011 15:21:25",
            "EndTime": "1/1/1900 00:00:00",
            "AmpFile": "20111003-134211.579040.amp",
            "ResultsHttp": "",
            "Executable": "AERMOD_EPA_MPI_11103.exe",
            "ProjectName": "TAMKO_S1_Silica_2009.ami",
            "MemoText": "112101.0058",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 1.742409,
            "ServerFee": 1.742409,
            "QueDiscount": 0,
            "InvoiceFlag": false,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
        {
            "RunId": 10,
            "InvoiceAmount": 10,
            "CpuClock": 0,
            "WorkEstimate": 43.89665,
            "ArrivalTime": "",
            "StartTime": "03/10/2011 15:21:25",
            "EndTime": "",
            "AmpFile": "20111003-134211.579040.amp",
            "ResultsHttp": "",
            "Executable": "AERMOD_EPA_MPI_11103.exe",
            "ProjectName": "TAMKO_S1_Silica_2009.ami",
            "MemoText": "112101.0058",
            "Email": "idonalds@trinityconsultants.com",
            "QRunId": 0,
            "QUserId": 0,
            "MyJobWait": 0,
            "RuntimeFee": 1.742409,
            "ServerFee": 1.742409,
            "QueDiscount": 0,
            "InvoiceFlag": false,
            "Position": 0,
            "IsRemoved": 0,
            "IsCancelled": false,
            "IsFailed": false
        },
    ]
}
*/
